var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var BENCH_ID = -1;
export var onDrop = function (item, monitor, teamSelection, setTeamSelection) {
    if (!item || !monitor)
        return;
    var dropResult = monitor.getDropResult();
    if (!dropResult)
        return;
    var updatedTeams = teamSelection.teams.map(function (team) { return (__assign(__assign({}, team), { players: team.players.filter(function (p) { return p.id !== item.id; }) })); });
    var updatedBench = teamSelection.bench.filter(function (p) { return p.id !== item.id; });
    if (dropResult.id === BENCH_ID) {
        updatedBench.push(item);
    }
    else {
        updatedTeams[dropResult.id] = __assign(__assign({}, updatedTeams[dropResult.id]), { players: __spreadArray(__spreadArray([], __read(updatedTeams[dropResult.id].players), false), [item], false) });
    }
    var newSelection = {
        teams: updatedTeams,
        bench: updatedBench,
    };
    setTeamSelection(newSelection);
    return newSelection;
};
